{
  "#MDC_INVENTORY": {
    "TITLE": "Inventory",
    "MODULE_TITLE": "Inventory",
    "DASHBOARD": "Dashboard",
    "TABLE": "Table",
    "NO_DATA": "No data available",
    "LIST": {
      "TITLE": "Capture",
      "POSITIONS": "Positions",
      "UNITS": "Units",
      "DIFFERENCE": "Diff.",
      "SEARCH_PLACEHOLDER": "Search in list…",
      "EMPTY": {
        "TITLE": "No items captured yet",
        "SUBTITLE": "Scan a barcode or add an item manually to begin."
      },
      "NO_RESULTS": "No results for “{{ term }}\".",
      "SCAN": "Continue scanning",
      "SEARCH_MANUAL": "Manual search",
      "ENTER_EAN": "Enter EAN",
      "FINISH": "Finish"
    },
    "DETAIL": {
      "TITLE": "Capture item",
      "RECOGNISED_BADGE": "Recognised",
      "RECOGNISED_AS": "Recognised: EAN-13",
      "EAN": "EAN",
      "EXPECTED_STOCK": "Expected stock",
      "QUANTITY_HEADER": "Capture quantity",
      "NOTE_HEADER": "Note (optional)",
      "NOTE_PLACEHOLDER": "e.g. damage, location, batch…",
      "CANCEL": "Cancel",
      "APPLY": "Apply"
    }
  }
}
